export default __webpack_public_path__ + "static/media/angle-double-right.b8ca52c4.svg";